import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import isEqualWith from 'lodash/isEqualWith';

import { API_DATE_FORMAT } from 'constants.js';

const comparator = (initialValue, currentValue) => {
  // compare and treat falsy values like null & empty string as the same
  if (!initialValue && !currentValue) return true;

  if (moment.isMoment(initialValue?.[0]) && moment.isMoment(currentValue?.[0])) {
    return (
      initialValue.map((date) => date.format(API_DATE_FORMAT)).join('-') ===
      currentValue.map((date) => date.format(API_DATE_FORMAT)).join('-')
    );
  }

  if (typeof initialValue === 'object') {
    return undefined;
  }

  return initialValue === currentValue;
};

export const areObjectsEqual = (initialState, currentState) => {
  const initialStateClone = cloneDeep(initialState);
  const currentStateClone = cloneDeep(currentState);
  return isEqualWith(initialStateClone, currentStateClone, comparator);
};

export const getTransformedObject = (originalObject) =>
  Object.entries(originalObject)
    .filter(([_, value]) => value !== undefined)
    .reduce(
      (preValues, [key, value]) => ({
        ...preValues,
        [key]: value
      }),
      {}
    );
